import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";

export const fmtDate = (v) => (v ? format(typeof v === "string" ? parseISO(v) : v, "dd MMM yyyy", { locale: es }) : "—");

export const fmtDateTime = (v) => (v ? format(typeof v === "string" ? parseISO(v) : v, "dd MMM yyyy, HH:mm", { locale: es }) : "—");

export const fmtPrice = (n) => `$${Number(n || 0).toLocaleString("es-EC", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
